var _mask, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEt = function SvgEt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "et_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v15H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#et_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v15h20V0H0z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "et_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v15h20V0H0z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#et_svg__b)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v5h20V0H0z",
    fill: "#40A8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5v5h20V5H0z",
    fill: "#272727"
  })))));
};

export default SvgEt;